import React from "react";
import { css, useTheme } from "@emotion/react";
import ContentCombine from "core/Components/ContentCombine";
import DoubleQuotes from "core/Components/Icons/DoubleQuotes";

type Props = {
    text: string,
    textColour?: string,
    useDoubleQuotes?: boolean,
};

const Quote: React.FC<Props> = ({
    text,
    textColour = 'white',
    useDoubleQuotes = false,
}) => {
    const theme = useTheme();

    const style = css`
        color: ${textColour};
        margin-top: 40px;

        ${theme.breakpoints.only('sm')} {
            width: 470px;
        }

        ${theme.breakpoints.down('xs')} {
            width: 323px;
        }
    `;

    const doubleQuotesStyle = css`
        margin-bottom: 15px;
    `;

    return (
        text ? (
            <div css={style}>
                {useDoubleQuotes && (
                    <DoubleQuotes
                        css={doubleQuotesStyle}
                        colour={'white'}
                    />
                )}
                <ContentCombine Tag={'p'} fontSizeType={'20'}>{text}</ContentCombine>
            </div>
        ) : null
    );
};

export default Quote;